module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="cw-multiLabel-bloc form-group" data-bloc-name="UNITE" data-bloc-label="'+
((__t=(i18n.t('common:gererprets.unite')))==null?'':__t)+
'">\r\n    <label for="unitedeb.code" class="sr-only"></label>\r\n    <span class="comboUnites"></span>\r\n</div>\r\n';
}
return __p;
};
